export const morpherOracleAbi = [
	{
	  "type": "function",
	  "name": "_CANCEL_ORDER_TYPEHASH",
	  "inputs": [],
	  "outputs": [{ "name": "", "type": "bytes32", "internalType": "bytes32" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "_PERMIT_TYPEHASH",
	  "inputs": [],
	  "outputs": [{ "name": "", "type": "bytes32", "internalType": "bytes32" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "__callback",
	  "inputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" },
		{ "name": "_price", "type": "uint256", "internalType": "uint256" },
		{
		  "name": "_unadjustedMarketPrice",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{ "name": "_spread", "type": "uint256", "internalType": "uint256" },
		{
		  "name": "_liquidationTimestamp",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{ "name": "_timeStamp", "type": "uint256", "internalType": "uint256" },
		{
		  "name": "_gasForNextCallback",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "createdPosition",
		  "type": "tuple",
		  "internalType": "struct MorpherTradeEngine.position",
		  "components": [
			{
			  "name": "lastUpdated",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "longShares",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "shortShares",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "meanEntryPrice",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "meanEntrySpread",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "meanEntryLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "liquidationPrice",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "positionHash",
			  "type": "bytes32",
			  "internalType": "bytes32"
			}
		  ]
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "adminLiquidationOrder",
	  "inputs": [
		{ "name": "_address", "type": "address", "internalType": "address" },
		{ "name": "_marketId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "callBackAddress",
	  "inputs": [{ "name": "", "type": "address", "internalType": "address" }],
	  "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "callBackCollectionAddress",
	  "inputs": [],
	  "outputs": [
		{ "name": "", "type": "address", "internalType": "address payable" }
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "cancelOrder",
	  "inputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "checkOrderConditions",
	  "inputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" },
		{ "name": "_price", "type": "uint256", "internalType": "uint256" }
	  ],
	  "outputs": [
		{ "name": "_conditionsMet", "type": "bool", "internalType": "bool" }
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "createLiquidationOrder",
	  "inputs": [
		{ "name": "_address", "type": "address", "internalType": "address" },
		{ "name": "_marketId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "createOrder",
	  "inputs": [
		{
		  "name": "createOrderParams",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.CreateOrderStruct",
		  "components": [
			{
			  "name": "_marketId",
			  "type": "bytes32",
			  "internalType": "bytes32"
			},
			{
			  "name": "_closeSharesAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_openMPHTokenAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_tradeDirection",
			  "type": "bool",
			  "internalType": "bool"
			},
			{
			  "name": "_orderLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceAbove",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceBelow",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodUntil",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodFrom",
			  "type": "uint256",
			  "internalType": "uint256"
			}
		  ]
		}
	  ],
	  "outputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "createOrder",
	  "inputs": [
		{ "name": "_marketId", "type": "bytes32", "internalType": "bytes32" },
		{
		  "name": "_closeSharesAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_openMPHTokenAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{ "name": "_tradeDirection", "type": "bool", "internalType": "bool" },
		{
		  "name": "_orderLeverage",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_onlyIfPriceAbove",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_onlyIfPriceBelow",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{ "name": "_goodUntil", "type": "uint256", "internalType": "uint256" },
		{ "name": "_goodFrom", "type": "uint256", "internalType": "uint256" }
	  ],
	  "outputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "createOrderFromGasToken",
	  "inputs": [
		{
		  "name": "createOrderParams",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.CreateOrderStruct",
		  "components": [
			{
			  "name": "_marketId",
			  "type": "bytes32",
			  "internalType": "bytes32"
			},
			{
			  "name": "_closeSharesAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_openMPHTokenAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_tradeDirection",
			  "type": "bool",
			  "internalType": "bool"
			},
			{
			  "name": "_orderLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceAbove",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceBelow",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodUntil",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodFrom",
			  "type": "uint256",
			  "internalType": "uint256"
			}
		  ]
		}
	  ],
	  "outputs": [
		{ "name": "orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "createOrderFromToken",
	  "inputs": [
		{
		  "name": "createOrderParams",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.CreateOrderStruct",
		  "components": [
			{
			  "name": "_marketId",
			  "type": "bytes32",
			  "internalType": "bytes32"
			},
			{
			  "name": "_closeSharesAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_openMPHTokenAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_tradeDirection",
			  "type": "bool",
			  "internalType": "bool"
			},
			{
			  "name": "_orderLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceAbove",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceBelow",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodUntil",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodFrom",
			  "type": "uint256",
			  "internalType": "uint256"
			}
		  ]
		},
		{
		  "name": "inputToken",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.TokenPermitEIP712Struct",
		  "components": [
			{
			  "name": "tokenAddress",
			  "type": "address",
			  "internalType": "address"
			},
			{ "name": "owner", "type": "address", "internalType": "address" },
			{ "name": "value", "type": "uint256", "internalType": "uint256" },
			{
			  "name": "minOutValue",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "deadline",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{ "name": "v", "type": "uint8", "internalType": "uint8" },
			{ "name": "r", "type": "bytes32", "internalType": "bytes32" },
			{ "name": "s", "type": "bytes32", "internalType": "bytes32" }
		  ]
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "createOrderFromToken",
	  "inputs": [
		{
		  "name": "createOrderParams",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.CreateOrderStruct",
		  "components": [
			{
			  "name": "_marketId",
			  "type": "bytes32",
			  "internalType": "bytes32"
			},
			{
			  "name": "_closeSharesAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_openMPHTokenAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_tradeDirection",
			  "type": "bool",
			  "internalType": "bool"
			},
			{
			  "name": "_orderLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceAbove",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceBelow",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodUntil",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodFrom",
			  "type": "uint256",
			  "internalType": "uint256"
			}
		  ]
		},
		{
		  "name": "inputToken",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.TokenPermitEIP712Struct",
		  "components": [
			{
			  "name": "tokenAddress",
			  "type": "address",
			  "internalType": "address"
			},
			{ "name": "owner", "type": "address", "internalType": "address" },
			{ "name": "value", "type": "uint256", "internalType": "uint256" },
			{
			  "name": "minOutValue",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "deadline",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{ "name": "v", "type": "uint8", "internalType": "uint8" },
			{ "name": "r", "type": "bytes32", "internalType": "bytes32" },
			{ "name": "s", "type": "bytes32", "internalType": "bytes32" }
		  ]
		},
		{
		  "name": "_addressPositionOwner",
		  "type": "address",
		  "internalType": "address"
		},
		{ "name": "deadline", "type": "uint256", "internalType": "uint256" },
		{ "name": "v", "type": "uint8", "internalType": "uint8" },
		{ "name": "r", "type": "bytes32", "internalType": "bytes32" },
		{ "name": "s", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "createOrderPermittedBySignature",
	  "inputs": [
		{
		  "name": "createOrderParams",
		  "type": "tuple",
		  "internalType": "struct MorpherOracle.CreateOrderStruct",
		  "components": [
			{
			  "name": "_marketId",
			  "type": "bytes32",
			  "internalType": "bytes32"
			},
			{
			  "name": "_closeSharesAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_openMPHTokenAmount",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_tradeDirection",
			  "type": "bool",
			  "internalType": "bool"
			},
			{
			  "name": "_orderLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceAbove",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_onlyIfPriceBelow",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodUntil",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "_goodFrom",
			  "type": "uint256",
			  "internalType": "uint256"
			}
		  ]
		},
		{
		  "name": "_addressPositionOwner",
		  "type": "address",
		  "internalType": "address"
		},
		{ "name": "deadline", "type": "uint256", "internalType": "uint256" },
		{ "name": "v", "type": "uint8", "internalType": "uint8" },
		{ "name": "r", "type": "bytes32", "internalType": "bytes32" },
		{ "name": "s", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [
		{ "name": "orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "initiateCancelOrder",
	  "inputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "initiateCancelOrderPermitted",
	  "inputs": [
		{ "name": "_orderId", "type": "bytes32", "internalType": "bytes32" },
		{ "name": "_owner", "type": "address", "internalType": "address" },
		{ "name": "deadline", "type": "uint256", "internalType": "uint256" },
		{ "name": "v", "type": "uint8", "internalType": "uint8" },
		{ "name": "r", "type": "bytes32", "internalType": "bytes32" },
		{ "name": "s", "type": "bytes32", "internalType": "bytes32" }
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "nonces",
	  "inputs": [
		{ "name": "owner", "type": "address", "internalType": "address" }
	  ],
	  "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "orderCancellationRequested",
	  "inputs": [{ "name": "", "type": "bytes32", "internalType": "bytes32" }],
	  "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "setCallbackCollectionAddress",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address payable"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherSwapHelperAddress",
	  "inputs": [
		{
		  "name": "_helperAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setStateAddress",
	  "inputs": [
		{ "name": "_address", "type": "address", "internalType": "address" }
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "uniswapRouter",
	  "inputs": [],
	  "outputs": [{ "name": "", "type": "address", "internalType": "address" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "useWhiteList",
	  "inputs": [],
	  "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "wMaticAddress",
	  "inputs": [],
	  "outputs": [{ "name": "", "type": "address", "internalType": "address" }],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "whiteList",
	  "inputs": [{ "name": "", "type": "address", "internalType": "address" }],
	  "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
	  "stateMutability": "view"
	},
	{
	  "type": "event",
	  "name": "AddressBlackListed",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "AddressWhiteListed",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "AdminLiquidationOrderCreated",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_address",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_marketId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_closeSharesAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_openMPHTokenAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_tradeDirection",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		},
		{
		  "name": "_orderLeverage",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "AdminOrderCancelled",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_sender",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_oracleAddress",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "LiquidationOrderCreated",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_sender",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_address",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_marketId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OrderCancellationRequestedEvent",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_sender",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OrderCancelled",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_sender",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_oracleAddress",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OrderCreated",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_address",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_marketId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_closeSharesAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_openMPHTokenAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_tradeDirection",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		},
		{
		  "name": "_orderLeverage",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_onlyIfPriceBelow",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_onlyIfPriceAbove",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_goodFrom",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_goodUntil",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OrderFailed",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_address",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_marketId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_closeSharesAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_openMPHTokenAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_tradeDirection",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		},
		{
		  "name": "_orderLeverage",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_onlyIfPriceBelow",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_onlyIfPriceAbove",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_goodFrom",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_goodUntil",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OrderProcessed",
	  "inputs": [
		{
		  "name": "_orderId",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		},
		{
		  "name": "_price",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_unadjustedMarketPrice",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_spread",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_positionLiquidationTimestamp",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_timeStamp",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newLongShares",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newShortShares",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newMeanEntry",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newMeanSprad",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newMeanLeverage",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_liquidationPrice",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
  ] as const;

export const morpherStateAbi = [
	{
	  "type": "function",
	  "name": "ADMINISTRATOR_ROLE",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "DECIMALS",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "GOVERNANCE_ROLE",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "PLATFORM_ROLE",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "PRECISION",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "REWARDPERIOD",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "activateMarket",
	  "inputs": [
		{
		  "name": "_activateMarket",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "deActivateMarket",
	  "inputs": [
		{
		  "name": "_deActivateMarket",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "getLastUpdated",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_marketHash",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getMarketActive",
	  "inputs": [
		{
		  "name": "_marketId",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [
		{
		  "name": "_active",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getMaximumLeverage",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "_maxLeverage",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getPosition",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_marketId",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [
		{
		  "name": "_longShares",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_shortShares",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_meanEntryPrice",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_meanEntrySpread",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_meanEntryLeverage",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_liquidationPrice",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "initialize",
	  "inputs": [
		{
		  "name": "_mainChain",
		  "type": "bool",
		  "internalType": "bool"
		},
		{
		  "name": "_morpherAccessControlAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "lastRewardTime",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "mainChain",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "mainChainWithdrawLimit24",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "maximumLeverage",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherAccessControlAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherAirdropAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherBridgeAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherFaucetAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherGovernanceAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherInterestRateManagerAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherMintingLimiterAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherOracleAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherRewards",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherStakingAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address payable"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherTokenAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherTradeEngineAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherUserBlockingAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "numberOfRequestsLimit",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "rewardBasisPoints",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "setMaximumLeverage",
	  "inputs": [
		{
		  "name": "_newMaximumLeverage",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherAccessControl",
	  "inputs": [
		{
		  "name": "_morpherAccessControlAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherAirdrop",
	  "inputs": [
		{
		  "name": "_morpherAirdropAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherBridge",
	  "inputs": [
		{
		  "name": "_morpherBridgeAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherFaucet",
	  "inputs": [
		{
		  "name": "_morpherFaucetAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherGovernance",
	  "inputs": [
		{
		  "name": "_morpherGovernanceAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherInterestRateManager",
	  "inputs": [
		{
		  "name": "_morpherInterestRateManagerAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherMintingLimiter",
	  "inputs": [
		{
		  "name": "_morpherMintingLimiterAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherOracle",
	  "inputs": [
		{
		  "name": "_morpherOracleAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherStaking",
	  "inputs": [
		{
		  "name": "_morpherStakingAddress",
		  "type": "address",
		  "internalType": "address payable"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherToken",
	  "inputs": [
		{
		  "name": "_morpherTokenAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherTradeEngine",
	  "inputs": [
		{
		  "name": "_morpherTradeEngineAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherUserBlocking",
	  "inputs": [
		{
		  "name": "_morpherUserBlockingAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "sideChainMerkleRoot",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "sideChainMerkleRootWrittenAtTime",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalToken",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "event",
	  "name": "Initialized",
	  "inputs": [
		{
		  "name": "version",
		  "type": "uint8",
		  "indexed": false,
		  "internalType": "uint8"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "LastRewardTime",
	  "inputs": [
		{
		  "name": "rewardsTime",
		  "type": "uint256",
		  "indexed": true,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MarketActivated",
	  "inputs": [
		{
		  "name": "activateMarket",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MarketDeActivated",
	  "inputs": [
		{
		  "name": "deActivateMarket",
		  "type": "bytes32",
		  "indexed": true,
		  "internalType": "bytes32"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MaximumLeverageChange",
	  "inputs": [
		{
		  "name": "maxLeverage",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OperatingRewardMinted",
	  "inputs": [
		{
		  "name": "recipient",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "RewardsChange",
	  "inputs": [
		{
		  "name": "rewardsAddress",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "rewardsBasisPoints",
		  "type": "uint256",
		  "indexed": true,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherAccessControlAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherAirdropAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherBridgeAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherFaucetAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherGovernanceAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherInterestRateManagerAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherMintingLimiterAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherOracleAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherStakingAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherTokenAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherTradeEngineAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetMorpherUserBlockingAddress",
	  "inputs": [
		{
		  "name": "_oldAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		},
		{
		  "name": "_newAddress",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	}
  ] as const;

export const morpherAirdropAbi = [
	{
	  "type": "constructor",
	  "inputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "fallback",
	  "stateMutability": "payable"
	},
	{
	  "type": "receive",
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "adminAuthorizeAndSend",
	  "inputs": [
		{
		  "name": "_recipient",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "adminSendAirdrop",
	  "inputs": [
		{
		  "name": "_recipient",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "adminSendLockedRewards",
	  "inputs": [
		{
		  "name": "_recipient",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "adminSendSomeAirdrop",
	  "inputs": [
		{
		  "name": "_recipient",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "airdropAdmin",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "claimAirdrop",
	  "inputs": [],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "claimSomeAirdrop",
	  "inputs": [
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "getAirdrop",
	  "inputs": [
		{
		  "name": "_userAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "_claimed",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_authorized",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getAirdropAuthorized",
	  "inputs": [
		{
		  "name": "_userAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "_balance",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getAirdropClaimed",
	  "inputs": [
		{
		  "name": "_userAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "initialize",
	  "inputs": [
		{
		  "name": "_airdropAdminAddress",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_morpherToken",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_coldStorageOwnerAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "morpherToken",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "owner",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "renounceOwnership",
	  "inputs": [],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setAirdropAdmin",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setAirdropAuthorized",
	  "inputs": [
		{
		  "name": "_userAddress",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_authorized",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherTokenAddress",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "totalAirdropAuthorized",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalAirdropClaimed",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "transferOwnership",
	  "inputs": [
		{
		  "name": "newOwner",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "event",
	  "name": "AirdropSent",
	  "inputs": [
		{
		  "name": "_operator",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_recipient",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_amountClaimed",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_amountAuthorized",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Initialized",
	  "inputs": [
		{
		  "name": "version",
		  "type": "uint8",
		  "indexed": false,
		  "internalType": "uint8"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "OwnershipTransferred",
	  "inputs": [
		{
		  "name": "previousOwner",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "newOwner",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetAirdropAuthorized",
	  "inputs": [
		{
		  "name": "_recipient",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "_amountClaimed",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_amountAuthorized",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	}
  ] as const;

export const morpherBridgeAbi = [
	{
	  "type": "function",
	  "name": "claimFailedTransferToSidechain",
	  "inputs": [
		{
		  "name": "_wrongSideChainBalance",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		},
		{
		  "name": "_targetChainId",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "claimStagedTokens",
	  "inputs": [
		{
		  "name": "_numOfToken",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_claimLimit",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "claimStagedTokensAndSendForUser",
	  "inputs": [
		{
		  "name": "_usrAddr",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_numOfToken",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "fee",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "feeRecipient",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_claimLimit",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		},
		{
		  "name": "_finalOutput",
		  "type": "address",
		  "internalType": "address payable"
		},
		{
		  "name": "_rootHash",
		  "type": "bytes32",
		  "internalType": "bytes32"
		},
		{
		  "name": "_userConfirmationSignature",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "claimStagedTokensConvertAndSend",
	  "inputs": [
		{
		  "name": "_numOfToken",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_claimLimit",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		},
		{
		  "name": "_finalOutput",
		  "type": "address",
		  "internalType": "address payable"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "claimStagedTokensConvertAndSendForUser",
	  "inputs": [
		{
		  "name": "_usrAddr",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_numOfToken",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "fee",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "feeRecipient",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_claimLimit",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		},
		{
		  "name": "_finalOutput",
		  "type": "address",
		  "internalType": "address payable"
		},
		{
		  "name": "_rootHash",
		  "type": "bytes32",
		  "internalType": "bytes32"
		},
		{
		  "name": "_userConfirmationSignature",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "getBalanceHash",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_balance",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "_hash",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "pure"
	},
	{
	  "type": "function",
	  "name": "isNotDailyLimitExceeding",
	  "inputs": [
		{
		  "name": "_usr",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "isNotMonthlyLimitExceeding",
	  "inputs": [
		{
		  "name": "_usr",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "isNotYearlyLimitExceeding",
	  "inputs": [
		{
		  "name": "_usr",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	
	{
	  "type": "function",
	  "name": "stageTokensForTransfer",
	  "inputs": [
		{
		  "name": "_tokens",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_targetChainId",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "stageTokensForTransfer",
	  "inputs": [
		{
		  "name": "_tokens",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_targetChainId",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_autoWithdrawalAddressTo",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_signature",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	
	{
	  "type": "function",
	  "name": "tokenClaimedOnThisChain",
	  "inputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "lastTransferAt",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "tokenSentToLinkedChain",
	  "inputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "lastTransferAt",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},

	{
	  "type": "function",
	  "name": "withdrawalLimitGlobalDaily",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "withdrawalLimitGlobalMonthly",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "withdrawalLimitGlobalYearly",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	

  ] as const;


  export const morpherTokenAbiOld = [
	{
		inputs: [
			{
				internalType: 'address',
				name: '_stateAddress',
				type: 'address'
			},
			{
				internalType: 'address',
				name: '_coldStorageOwnerAddress',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'constructor'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'owner',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'spender',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'value',
				type: 'uint256'
			}
		],
		name: 'Approval',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: '_address',
				type: 'address'
			}
		],
		name: 'LinkState',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'previousOwner',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'OwnershipTransferred',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'from',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'value',
				type: 'uint256'
			}
		],
		name: 'Transfer',
		type: 'event'
	},
	{
		payable: true,
		stateMutability: 'payable',
		type: 'fallback'
	},
	{
		constant: true,
		inputs: [],
		name: '_owner',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'decimals',
		outputs: [
			{
				internalType: 'uint8',
				name: '',
				type: 'uint8'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'isOwner',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'name',
		outputs: [
			{
				internalType: 'string',
				name: '',
				type: 'string'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'owner',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [],
		name: 'renounceOwnership',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'symbol',
		outputs: [
			{
				internalType: 'string',
				name: '',
				type: 'string'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_tokenAddress',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_tokens',
				type: 'uint256'
			}
		],
		name: 'transferAnyERC20Token',
		outputs: [
			{
				internalType: 'bool',
				name: '_success',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'transferOwnership',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_stateAddress',
				type: 'address'
			}
		],
		name: 'setMorpherState',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'totalSupply',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '_account',
				type: 'address'
			}
		],
		name: 'balanceOf',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_recipient',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_amount',
				type: 'uint256'
			}
		],
		name: 'transfer',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '_owner',
				type: 'address'
			},
			{
				internalType: 'address',
				name: '_spender',
				type: 'address'
			}
		],
		name: 'allowance',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_spender',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_amount',
				type: 'uint256'
			}
		],
		name: 'approve',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_sender',
				type: 'address'
			},
			{
				internalType: 'address',
				name: '_recipient',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: 'amount',
				type: 'uint256'
			}
		],
		name: 'transferFrom',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_spender',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_addedValue',
				type: 'uint256'
			}
		],
		name: 'increaseAllowance',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_spender',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_subtractedValue',
				type: 'uint256'
			}
		],
		name: 'decreaseAllowance',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'uint256',
				name: '_amount',
				type: 'uint256'
			}
		],
		name: 'burn',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				internalType: 'address',
				name: '_to',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_amount',
				type: 'uint256'
			}
		],
		name: 'emitTransfer',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	}
] as const;

export const morpherTokenAbi = [
	{
	  "type": "function",
	  "name": "allowance",
	  "inputs": [
		{
		  "name": "owner",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "spender",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "approve",
	  "inputs": [
		{
		  "name": "spender",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "value",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "balanceOf",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "burn",
	  "inputs": [
		{
		  "name": "from",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "decimals",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint8",
		  "internalType": "uint8"
		}
	  ],
	  "stateMutability": "view"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "version",
		"outputs": [
		  {
			"name": "",
			"type": "string"
		  }
		],
		"payable": false,
		"type": "function"
	},
	{
	  "type": "function",
	  "name": "deposit",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "depositData",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "getDailyMintedTransferLimit",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getDailyMintedTransfers",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getLockedRewards",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getRestrictTransfers",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTimeLock",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "lockedUntil",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTotalLockedRewards",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTotalTimeLocked",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTotalTokensInPositions",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTradeableBalanceOf",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTransferredInTokens",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "initialize",
	  "inputs": [
		{
		  "name": "_morpherAccessControlAddress",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_morpherStateAddress",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_permitName",
		  "type": "string",
		  "internalType": "string"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "lockRewards",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "lockTokensForTime",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "lockDuration",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "mint",
	  "inputs": [
		{
		  "name": "to",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "morpherAccessControl",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "contract MorpherAccessControl"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "morpherState",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "contract MorpherState"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "name",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "string",
		  "internalType": "string"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "nonces",
	  "inputs": [
		{
		  "name": "owner",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "pause",
	  "inputs": [],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "paused",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "permit",
	  "inputs": [
		{
		  "name": "owner",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "spender",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "value",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "deadline",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "v",
		  "type": "uint8",
		  "internalType": "uint8"
		},
		{
		  "name": "r",
		  "type": "bytes32",
		  "internalType": "bytes32"
		},
		{
		  "name": "s",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "proxiableUUID",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "setDailyMintedTransferLimit",
	  "inputs": [
		{
		  "name": "limit",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherStateAddress",
	  "inputs": [
		{
		  "name": "_morpherState",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setRestrictTransfers",
	  "inputs": [
		{
		  "name": "restrictTransfers",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setTotalInPositions",
	  "inputs": [
		{
		  "name": "totalTokensInPositions",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "symbol",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "string",
		  "internalType": "string"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalSupply",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "transfer",
	  "inputs": [
		{
		  "name": "to",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "value",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "transferFrom",
	  "inputs": [
		{
		  "name": "from",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "to",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "value",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "unlockExpiredTokens",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "unlockRewards",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "unpause",
	  "inputs": [],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "upgradeToAndCall",
	  "inputs": [
		{
		  "name": "newImplementation",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "data",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "withdraw",
	  "inputs": [
		{
		  "name": "amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "event",
	  "name": "Approval",
	  "inputs": [
		{
		  "name": "owner",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "spender",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "value",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "DailyMintedTransferLimitUpdated",
	  "inputs": [
		{
		  "name": "oldLimit",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "newLimit",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "EIP712DomainChanged",
	  "inputs": [],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Initialized",
	  "inputs": [
		{
		  "name": "version",
		  "type": "uint64",
		  "indexed": false,
		  "internalType": "uint64"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MigrationTokensLocked",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "lockedUntil",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MintedTokensTransferred",
	  "inputs": [
		{
		  "name": "from",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "to",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Paused",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "RewardsLocked",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "RewardsUnlocked",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetRestrictTransfers",
	  "inputs": [
		{
		  "name": "_oldValue",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		},
		{
		  "name": "_newValue",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetTotalTokensInPositions",
	  "inputs": [
		{
		  "name": "_oldValue",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newValue",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "SetTotalTokensOnOtherChain",
	  "inputs": [
		{
		  "name": "_oldValue",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "_newValue",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "TokensLocked",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "lockedUntil",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "TokensTransferredIn",
	  "inputs": [
		{
		  "name": "to",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "TokensUnlocked",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Transfer",
	  "inputs": [
		{
		  "name": "from",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "to",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "value",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Unpaused",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "indexed": false,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Upgraded",
	  "inputs": [
		{
		  "name": "implementation",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "error",
	  "name": "AddressEmptyCode",
	  "inputs": [
		{
		  "name": "target",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ECDSAInvalidSignature",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "ECDSAInvalidSignatureLength",
	  "inputs": [
		{
		  "name": "length",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ECDSAInvalidSignatureS",
	  "inputs": [
		{
		  "name": "s",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC1967InvalidImplementation",
	  "inputs": [
		{
		  "name": "implementation",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC1967NonPayable",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "ERC20InsufficientAllowance",
	  "inputs": [
		{
		  "name": "spender",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "allowance",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "needed",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC20InsufficientBalance",
	  "inputs": [
		{
		  "name": "sender",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "balance",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "needed",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC20InvalidApprover",
	  "inputs": [
		{
		  "name": "approver",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC20InvalidReceiver",
	  "inputs": [
		{
		  "name": "receiver",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC20InvalidSender",
	  "inputs": [
		{
		  "name": "sender",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC20InvalidSpender",
	  "inputs": [
		{
		  "name": "spender",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC2612ExpiredSignature",
	  "inputs": [
		{
		  "name": "deadline",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC2612InvalidSigner",
	  "inputs": [
		{
		  "name": "signer",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "owner",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "EnforcedPause",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "ExpectedPause",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "FailedCall",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "InvalidAccountNonce",
	  "inputs": [
		{
		  "name": "account",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "currentNonce",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "InvalidInitialization",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "NotInitializing",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "UUPSUnauthorizedCallContext",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "UUPSUnsupportedProxiableUUID",
	  "inputs": [
		{
		  "name": "slot",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ]
	}
  ] as const;

export const morpherMigrationAbi = [
	{
		inputs: [
			{
				internalType: 'address',
				name: '_morpherTokenAddress',
				type: 'address'
			},
			{
				internalType: 'address',
				name: '_morpherStateAddress',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'constructor'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'bytes32',
				name: '_marketId',
				type: 'bytes32'
			},
			{
				indexed: false,
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'address',
				name: '_to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: '_timestamp',
				type: 'uint256'
			}
		],
		name: 'MarketMigrationComplete',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'address',
				name: '_to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: '_timestamp',
				type: 'uint256'
			}
		],
		name: 'MigrationComplete',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'address',
				name: '_to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: '_timestamp',
				type: 'uint256'
			}
		],
		name: 'MigrationIncomplete',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'address',
				name: '_to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: '_timestamp',
				type: 'uint256'
			}
		],
		name: 'MigrationPermissionGiven',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'previousOwner',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'OwnershipTransferred',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'address',
				name: '_to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: '_amount',
				type: 'uint256'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: '_timestamp',
				type: 'uint256'
			}
		],
		name: 'TokenMigrationComplete',
		type: 'event'
	},
	{
		constant: true,
		inputs: [],
		name: '_owner',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		name: 'destinationAddressAllowsOverwriting',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'isOwner',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [],
		name: 'owner',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		name: 'ownerSetMigrationAllowance',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [],
		name: 'renounceOwnership',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		name: 'sourceAddressAllowedToOverwriteTo',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		name: 'sourceAddressMigrationFinished',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: true,
		inputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		name: 'sourceAddressMigrationStarted',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'view',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_tokenAddress',
				type: 'address'
			},
			{
				internalType: 'uint256',
				name: '_tokens',
				type: 'uint256'
			}
		],
		name: 'transferAnyERC20Token',
		outputs: [
			{
				internalType: 'bool',
				name: '_success',
				type: 'bool'
			}
		],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'transferOwnership',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'bytes32[]',
				name: '_marketHashes',
				type: 'bytes32[]'
			}
		],
		name: 'addMarketHashes',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_from',
				type: 'address'
			}
		],
		name: 'allowMigrationFrom',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_from',
				type: 'address'
			},
			{
				internalType: 'address',
				name: '_to',
				type: 'address'
			}
		],
		name: 'ownerConfirmMigrationAddresses',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		constant: false,
		inputs: [
			{
				internalType: 'address',
				name: '_to',
				type: 'address'
			}
		],
		name: 'startMigrate',
		outputs: [],
		payable: false,
		stateMutability: 'nonpayable',
		type: 'function'
	}
  ];

export const morpherStakingABI = [
	{
	  "type": "function",
	  "name": "_STAKE_TYPEHASH",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "_UNSTAKE_TYPEHASH",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getStake",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "_poolShares",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getStakeValue",
	  "inputs": [
		{
		  "name": "_address",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "_value",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lastUpdate",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getTotalPooledValue",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "_totalPooled",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "interestRate",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "lastReward",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "lockupPeriod",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "minimumStake",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "nonces",
	  "inputs": [
		{
		  "name": "owner",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "poolShareValue",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "poolShares",
	  "inputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "numPoolShares",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "lockedUntil",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "stake",
	  "inputs": [
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "_poolShares",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "stakeWithPermit",
	  "inputs": [
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_owner",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "deadline",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "v",
		  "type": "uint8",
		  "internalType": "uint8"
		},
		{
		  "name": "r",
		  "type": "bytes32",
		  "internalType": "bytes32"
		},
		{
		  "name": "s",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "stakingAddress",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalShares",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "unstake",
	  "inputs": [
		{
		  "name": "_numOfShares",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "_amount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "unstakeWithPermit",
	  "inputs": [
		{
		  "name": "_shares",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_owner",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "deadline",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "v",
		  "type": "uint8",
		  "internalType": "uint8"
		},
		{
		  "name": "r",
		  "type": "bytes32",
		  "internalType": "bytes32"
		},
		{
		  "name": "s",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "event",
	  "name": "Staked",
	  "inputs": [
		{
		  "name": "userAddress",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": true,
		  "internalType": "uint256"
		},
		{
		  "name": "poolShares",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "lockedUntil",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Unstaked",
	  "inputs": [
		{
		  "name": "userAddress",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": true,
		  "internalType": "uint256"
		},
		{
		  "name": "poolShares",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	}
  ] as const;
  

export const morpherSidechainToBaseMigrationAbi = [
	{
	  "type": "function",
	  "name": "ADMINISTRATOR_ROLE",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "MIGRATION_OPERATOR_ROLE",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "UPGRADE_INTERFACE_VERSION",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "string",
		  "internalType": "string"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "delegateMigrateBalance",
	  "inputs": [
		{
		  "name": "_user",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_userAuthSignature",
		  "type": "bytes",
		  "internalType": "bytes"
		},
		{
		  "name": "_balance",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockedAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockDuration",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockedRewardAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "delegateMigratePositionsBatch",
	  "inputs": [
		{
		  "name": "_user",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_userAuthSignature",
		  "type": "bytes",
		  "internalType": "bytes"
		},
		{
		  "name": "_positions",
		  "type": "tuple[]",
		  "internalType": "struct MorpherSidechainToBaseMigration.PositionMigrationData[]",
		  "components": [
			{
			  "name": "marketId",
			  "type": "bytes32",
			  "internalType": "bytes32"
			},
			{
			  "name": "timeStamp",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "longShares",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "shortShares",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "meanEntryPrice",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "meanEntrySpread",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "meanEntryLeverage",
			  "type": "uint256",
			  "internalType": "uint256"
			},
			{
			  "name": "liquidationPrice",
			  "type": "uint256",
			  "internalType": "uint256"
			}
		  ]
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "finalBalanceMerkleRoot",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "getMigrationStats",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "_totalPositionsMigrated",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_totalBalancesMigrated",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_totalUsersMigrated",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_migrationActive",
		  "type": "bool",
		  "internalType": "bool"
		},
		{
		  "name": "_finalBalanceRootSet",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "initialize",
	  "inputs": [
		{
		  "name": "_stateAddress",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_plasmaStateRoot",
		  "type": "bytes32",
		  "internalType": "bytes32"
		},
		{
		  "name": "_migrationBonusBps",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "initiateFullMigration",
	  "inputs": [
		{
		  "name": "_signature",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "lastMigratedPositionIndex",
	  "inputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "migrateBalanceSelfService",
	  "inputs": [
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		},
		{
		  "name": "_balance",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockedAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockDuration",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockedRewardAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "migratedBalances",
	  "inputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "migratedPositions",
	  "inputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "migrationBonus",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "migrationPaused",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "pauseMigration",
	  "inputs": [
		{
		  "name": "_paused",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "plasmaStateRoot",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "proxiableUUID",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "setFinalBalanceMerkleRoot",
	  "inputs": [
		{
		  "name": "_root",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "setMorpherState",
	  "inputs": [
		{
		  "name": "_stateAddress",
		  "type": "address",
		  "internalType": "address"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "state",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "contract MorpherState"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalBalancesMigrated",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalPositionsMigrated",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "totalUsersMigrated",
	  "inputs": [],
	  "outputs": [
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "updatePlasmaStateRoot",
	  "inputs": [
		{
		  "name": "_newRoot",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "nonpayable"
	},
	{
	  "type": "function",
	  "name": "upgradeToAndCall",
	  "inputs": [
		{
		  "name": "newImplementation",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "data",
		  "type": "bytes",
		  "internalType": "bytes"
		}
	  ],
	  "outputs": [],
	  "stateMutability": "payable"
	},
	{
	  "type": "function",
	  "name": "userPositionIds",
	  "inputs": [
		{
		  "name": "",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "function",
	  "name": "verifyBalanceSelfService",
	  "inputs": [
		{
		  "name": "_user",
		  "type": "address",
		  "internalType": "address"
		},
		{
		  "name": "_proof",
		  "type": "bytes32[]",
		  "internalType": "bytes32[]"
		},
		{
		  "name": "_balance",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockedAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockDuration",
		  "type": "uint256",
		  "internalType": "uint256"
		},
		{
		  "name": "_lockedRewardAmount",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ],
	  "outputs": [
		{
		  "name": "",
		  "type": "bool",
		  "internalType": "bool"
		}
	  ],
	  "stateMutability": "view"
	},
	{
	  "type": "event",
	  "name": "BalanceMigrated",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "BalanceMigratedWithTimeLock",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "amount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "lockedAmount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "lockedUntil",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "DelegateMigrationAuthorized",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "delegate",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "authorized",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "FinalBalanceMerkleRootSet",
	  "inputs": [
		{
		  "name": "newRoot",
		  "type": "bytes32",
		  "indexed": false,
		  "internalType": "bytes32"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Initialized",
	  "inputs": [
		{
		  "name": "version",
		  "type": "uint64",
		  "indexed": false,
		  "internalType": "uint64"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MigrationInitiated",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "MigrationPaused",
	  "inputs": [
		{
		  "name": "paused",
		  "type": "bool",
		  "indexed": false,
		  "internalType": "bool"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "PlasmaStateRootUpdated",
	  "inputs": [
		{
		  "name": "newRoot",
		  "type": "bytes32",
		  "indexed": false,
		  "internalType": "bytes32"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "PositionMigrated",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "marketId",
		  "type": "bytes32",
		  "indexed": false,
		  "internalType": "bytes32"
		},
		{
		  "name": "longShares",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "shortShares",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "positionHash",
		  "type": "bytes32",
		  "indexed": false,
		  "internalType": "bytes32"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "PositionsBatchMigrated",
	  "inputs": [
		{
		  "name": "user",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		},
		{
		  "name": "positionCount",
		  "type": "uint256",
		  "indexed": false,
		  "internalType": "uint256"
		},
		{
		  "name": "positionHashes",
		  "type": "bytes32[]",
		  "indexed": false,
		  "internalType": "bytes32[]"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "event",
	  "name": "Upgraded",
	  "inputs": [
		{
		  "name": "implementation",
		  "type": "address",
		  "indexed": true,
		  "internalType": "address"
		}
	  ],
	  "anonymous": false
	},
	{
	  "type": "error",
	  "name": "AddressEmptyCode",
	  "inputs": [
		{
		  "name": "target",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ECDSAInvalidSignature",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "ECDSAInvalidSignatureLength",
	  "inputs": [
		{
		  "name": "length",
		  "type": "uint256",
		  "internalType": "uint256"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ECDSAInvalidSignatureS",
	  "inputs": [
		{
		  "name": "s",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC1967InvalidImplementation",
	  "inputs": [
		{
		  "name": "implementation",
		  "type": "address",
		  "internalType": "address"
		}
	  ]
	},
	{
	  "type": "error",
	  "name": "ERC1967NonPayable",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "FailedCall",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "InvalidInitialization",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "NotInitializing",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "UUPSUnauthorizedCallContext",
	  "inputs": []
	},
	{
	  "type": "error",
	  "name": "UUPSUnsupportedProxiableUUID",
	  "inputs": [
		{
		  "name": "slot",
		  "type": "bytes32",
		  "internalType": "bytes32"
		}
	  ]
	}
  ] as const;

